const GOOGLE_VOICE_URI_IDENTIFIER = 'Google';
const MICROSOFT_VOICE_URI_IDENTIFIER = 'Microsoft';
const APPLE_VOICE_URI_IDENTIFIER = 'com.apple.voice.compact';

export function getVoiceByLanguage(language: string): SpeechSynthesisVoice | null {
  const languageFormatted = language.replace('_', '-').toUpperCase();
  const availableVoices = window.speechSynthesis.getVoices().filter(v => v.lang.toUpperCase().startsWith(languageFormatted));

  if (!availableVoices || !availableVoices.length) {
    return null;
  }

  const googleVoice = availableVoices.find(v => v.voiceURI.indexOf(GOOGLE_VOICE_URI_IDENTIFIER) !== -1);
  if (googleVoice) return googleVoice;

  const microsoftVoice = availableVoices.find(v => v.voiceURI.indexOf(MICROSOFT_VOICE_URI_IDENTIFIER) !== -1);
  if (microsoftVoice) return microsoftVoice;

  const appleVoice = availableVoices.find(v => v.voiceURI.indexOf(APPLE_VOICE_URI_IDENTIFIER) !== -1);
  if (appleVoice) return appleVoice;

  // fallback to first available voice
  return availableVoices[0];
}
